import React from "react";
import "./styles.scss";

const CustomMenu = ({ className = "", selectedKeys = [], mode = "horizontal", children }) => {
  return (
    <div className={`custom-menu ${mode} ${className}`}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return null;

        const isSelected = selectedKeys.includes(child.key);
        return React.cloneElement(child, {
          className: `custom-menu-item ${child.props.className || ""} ${isSelected ? "selected" : ""}`,
        });
      })}
    </div>
  );
};

const MenuItem = ({ key, className = "", onClick, children }) => {
  return (
    <div className={`custom-menu-item-content ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

CustomMenu.Item = MenuItem;

export default CustomMenu;
